import { remove, replace, setOrderDirection } from '../transformers/orderByField';
import { assignParent } from './common';
function acceptOrderByField(visitor) {
  return visitor.visitOrderByField ? visitor.visitOrderByField(this) : visitor.visitChildren(this);
}
function enterNode(listener) {
  listener.enterOrderByField && listener.enterOrderByField(this);
}
function exitNode(listener) {
  listener.exitOrderByField && listener.exitOrderByField(this);
}
function getChildren() {
  var children = [this.field];
  if (this.direction) {
    children.push(this.direction);
  }
  return children;
}
export var orderByField = function orderByField(field, direction) {
  return orderByFieldInternal(field, direction);
};
export var orderByFieldInternal = function orderByFieldInternal(field, direction) {
  var position = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var node = {
    field: field,
    direction: direction,
    position: position,
    accept: acceptOrderByField,
    enterNode: enterNode,
    exitNode: exitNode,
    getChildren: getChildren,
    parent: null,
    setOrderDirection: setOrderDirection,
    replace: replace,
    remove: remove
  };
  assignParent(node);
  return node;
};